module.exports = __webpack_public_path__ + "img/size-icon.090e1148.png";